module.exports = __webpack_public_path__ + "static/media/53.8344b05e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/53.jpg
// module id = 997
// module chunks = 0